export default "__VITE_ASSET___WqP3m4m__"